"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListBox = ListBox;
var React = _interopRequireWildcard(require("react"));
var _reactAria = require("react-aria");
var _Option = require("./Option");
var _ComboboxStyles = require("./ComboboxStyles");
var _jsxRuntime = require("react/jsx-runtime");
/*
 * This ListBox is taken from the example on the react-aria docs: https://react-spectrum.adobe.com/react-aria/useComboBox.html
 *
 * It does not support sections - this needs to be implemented - an example is available here https://github.com/NadiaPosch/react-aria-dropdown/tree/main
 * */

function ListBox(props) {
  var ref = React.useRef(null);
  var _props$listBoxRef = props.listBoxRef,
    listBoxRef = _props$listBoxRef === void 0 ? ref : _props$listBoxRef,
    state = props.state;
  var _ref = (0, _reactAria.useListBox)(props, state, listBoxRef),
    listBoxProps = _ref.listBoxProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ComboboxStyles.List, _objectSpread({}, listBoxProps, {
    ref: listBoxRef,
    children: _toConsumableArray(state.collection).map(function (item) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Option.Option, {
        item: item,
        state: state
      }, item.key);
    })
  }));
}